import React from "react";

const BrickIcon = ({ width = 11.896, height = 10.572 }) => {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 11.896 10.572"
      >
        <path
          id="firewall"
          d="M.38,15.144a.38.38,0,0,1-.38-.38V13.451a.38.38,0,0,1,.38-.38H5.188a.38.38,0,0,1,.38.38v1.313a.38.38,0,0,1-.38.38Zm11.136,0a.38.38,0,0,0,.38-.38V13.451a.38.38,0,0,0-.38-.38H6.708a.38.38,0,0,0-.38.38v1.313a.38.38,0,0,0,.38.38ZM8.352,17.977a.38.38,0,0,0,.38-.38V16.284a.38.38,0,0,0-.38-.38H3.544a.38.38,0,0,0-.38.38V17.6a.38.38,0,0,0,.38.38H8.352Zm-6.328,0a.38.38,0,0,0,.38-.38V16.284a.38.38,0,0,0-.38-.38H.408a.38.38,0,0,0-.38.38V17.6a.38.38,0,0,0,.38.38H2.024Zm9.464,0a.38.38,0,0,0,.38-.38V16.284a.38.38,0,0,0-.38-.38H9.872a.38.38,0,0,0-.38.38V17.6a.38.38,0,0,0,.38.38h1.616Zm-6.3,2.833a.38.38,0,0,0,.38-.38V19.117a.38.38,0,0,0-.38-.38H.38a.38.38,0,0,0-.38.38V20.43a.38.38,0,0,0,.38.38Zm6.328,0a.38.38,0,0,0,.38-.38V19.117a.38.38,0,0,0-.38-.38H6.708a.38.38,0,0,0-.38.38V20.43a.38.38,0,0,0,.38.38ZM8.352,23.643a.38.38,0,0,0,.38-.38V21.95a.38.38,0,0,0-.38-.38H3.544a.38.38,0,0,0-.38.38v1.313a.38.38,0,0,0,.38.38Zm-6.328,0a.38.38,0,0,0,.38-.38V21.95a.38.38,0,0,0-.38-.38H.408a.38.38,0,0,0-.38.38v1.313a.38.38,0,0,0,.38.38Zm9.464,0a.38.38,0,0,0,.38-.38V21.95a.38.38,0,0,0-.38-.38H9.872a.38.38,0,0,0-.38.38v1.313a.38.38,0,0,0,.38.38Z"
          transform="translate(0 -13.071)"
          fill="#1198ff"
        />
      </svg>
    </>
  );
};
export default BrickIcon;
